export const APP_CONST = Object.freeze({
  AUTH_ACTIONS: {
    LOGIN: "login",
    REGISTER: "register",
  },
  TOAST_TYPE: {
    ERROR: "error",
    SUCCESS: "success",
    INFO: "info",
    WARNING: "warning",
  },
  SPORTS_ID: {
    CIRCKET: "4",
    SOCCER: "1",
    TENNIS: "2",
  },
  ALL_MARKET_IDS: {
    CRICKET: "CRICKET_IDS",
    SOCCER: "SOCCER_IDS",
    TENNIS: "TENNIS_IDS",
  },
  ODDS_TYPE: {
    BACK: "back",
    LAY: "lay",
  },
  AUTH_MODAL: {
    LOGIN: "login",
    REGISTER: "register",
    MOBILE_NUMBER: "mobileNumber",
    VERIFY_NUMBER: "verifyNumber",
    FORGOTO_PASSWORD: "forgotpassword",
    RESET_PASSWORD: "resetpassword",
  },
  TEST: {},
  PLAYER_BANK_DETAILS_TYPE: {
    Bank: "bank",
    Card: "card",
  },
  ORGANISATION_STATUS: {
    Maintenance: "maintenance",
    Live: "live",
    Suspended: "suspended",
  },
});

export const PASSWORD_UPDATE_TYPE = {
  type0: "t0",
  type1: "t1",
};

export const DEFAULT_APP_ROUTES = Object.freeze({
  PUBLIC: "/",
  PROTECTED: "/home",
});

export const UPDATE_PASSWORD_FLAG_KEY = "psdupdt";

export const GTW_MODE = {
  Deposit: "deposit",
  Withdraw: "withdraw",
};

export const BankModeRequiredFields = [
  "accountNo",
  "accountName",
  "iban",
  "ifscCode",
  "bankName",
];

export const TransactionsType = {
  Cashier: "cashier",
  Mybets: "mybets",
  Withdraw: "withdraw",
  Deposit: "deposit",
};

export const TransactionsReferenceType = Object.freeze({
  ManualDeposit: "m_deposit",
  ManualWithdraw: "m_withdraw",
  CasinoWin: "casino_cr",
  CasinoLoss: "casino_dr",
  SportWin: "sports_cr",
  SportLoss: "sports_dr",
  OnlineDeposit: "o_deposit",
  OnlineWithdraw: "o_withdraw",
  BonusCredit: "bonus_cr",
  LcCredit: "lc_cr",
});

export const DefaultPageSize = 15;

export const TxnTypes = Object.freeze({
  Credit: "credit",
  Debit: "debit",
});

export const DefaultDateFormat = "DD MMM YYYY hh:mm A";
